import React from "react";
import { animated, useSpring } from "react-spring";
import styles from "./styles.module.scss";
import { track } from "../../../utils/amplitude";
import cn from "classnames";

const Accordion = ({ title, children, titleStyles }) => {
  const [open, setOpen] = React.useState(false);
  const showBlock = useSpring(
    open
      ? {
          maxHeight: "1000px",
          opacity: 1,
          transform: "translateY(0)",
          delay: 0,
        }
      : {
          opacity: 0,
          transform: "translateY(-20px)",
          delay: 30,
          maxHeight: "0px",
        }
  );
  return (
    <div className={styles.accordion}>
      <div
        className={cn(styles.title, titleStyles, open && "open")}
        onClick={() => {
          track("page_faq_item_opened", { faq_title: title });
          setOpen(!open);
        }}
      >
        {title}
      </div>
      <animated.div style={showBlock} className={styles.item}>
        <div className={styles.content}>
          <span>{children}</span>
        </div>
      </animated.div>
    </div>
  );
};

export default Accordion;
